import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { isMainTabsRoute, type NavigationManifestItem } from './navigationManifest';
import { navigateInShell } from './rootNavigation';

type NavLike = NavigationProp<ParamListBase>;

/**
 * Navega a un ítem del manifiesto desde el ShellStack / root (sidebar web, deep links).
 */
export function navigateToManifestItemFromShell(
  navigation: NavLike,
  item: NavigationManifestItem
): void {
  const state = navigation.getState();
  // The layout callback can provide ShellStack directly.
  if (state.routeNames.includes('MainTabs')) {
    navigateInShell(navigation, item.route);
    return;
  }
  // Otherwise the desktop sidebar is a sibling of ShellStack, so its
  // navigation object is RootStack. Target ShellStack explicitly; navigating
  // to AppShell again does not reliably change its already-focused child.
  const appShell = state.routes.find((route) => route.name === 'AppShell');
  const shellKey = (appShell as { state?: { key?: string } } | undefined)?.state?.key;
  if (shellKey) {
    navigation.dispatch({
      type: 'NAVIGATE',
      target: shellKey,
      payload: {
        name: isMainTabsRoute(item.route) ? 'MainTabs' : item.route,
        ...(isMainTabsRoute(item.route) ? { params: { screen: item.route } } : {}),
      },
    });
    return;
  }

  // Fallback for the brief period before ShellStack exposes its state.
  if (isMainTabsRoute(item.route)) {
    navigation.navigate('AppShell', { screen: 'MainTabs', params: { screen: item.route } });
  } else {
    navigation.navigate('AppShell', { screen: item.route });
  }
}

/**
 * Navega desde el tab navigator (MoreHub / Home) hacia un destino del manifiesto.
 */
export function navigateToManifestItemFromMainTabs(
  navigation: NavLike,
  item: NavigationManifestItem,
  params?: object
): void {
  if (isMainTabsRoute(item.route)) {
    // Tab routes are registered dynamically from the manifest.
    (navigation as { navigate: (route: string, p?: object) => void }).navigate(item.route, params);
    return;
  }
  navigateInShell(navigation, item.route, params);
}
